import { useMemo } from 'react';
import { BaseModel, Category } from 'src/types/model.types';
import { useCustomSelector } from 'src/store/reducer';
import { GET_MODELS_KEY, GET_CATEGORIES_KEY } from 'src/graphql/models/query';

export type AppModelDataType = {
    // loading: boolean;
    existingCategories: Array<number>;
    categories?: Array<Category>;
};

export function useAppModelSidebar(
    data: {
        [GET_MODELS_KEY]: Array<BaseModel>;
        [GET_CATEGORIES_KEY]: Array<Category>;
    }
    // error: any
): AppModelDataType {
    const activeModel = useCustomSelector((state) => state.reducers.activeModel);

    const {
        existingCategories
    }: {
        existingCategories: Array<number>;
    } = useMemo(() => {
        if (!data?.models)
            return { filteredPage: {}, pagesWithCategory: [], existingCategories: [] };
        const pagesWithCategory = data.models.map((m) => ({
            ...m,
            category: data.categories.filter((c) => c.categoryId === m.categoryId)[0]
        }));
        const existingCategories = pagesWithCategory.map((c) => c.categoryId);

        return { existingCategories };
    }, [data, activeModel]);

    return {
        // loading: !data && !error,
        existingCategories,
        categories: data?.categories
    };
}
